import { render, staticRenderFns } from "./op005a.vue?vue&type=template&id=0001666c"
import script from "./op005a.vue?vue&type=script&lang=js"
export * from "./op005a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports